(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeHero = (hero) => {
    if (hero.dataset.hitchHeroInitialized === 'true') return;

    hero.dataset.hitchHeroInitialized = 'true';

    const wrappers = Array.from(hero.querySelectorAll('[data-hitch-hero-video-wrapper]'));
    const control = hero.querySelector('[data-hitch-hero-video-control]');
    const autoplayEnabled = hero.dataset.videoAutoplay === 'true';
    const pauseWhenHidden = hero.dataset.videoPauseWhenHidden === 'true';
    let isVisible = true;
    let userPaused = !autoplayEnabled;
    let activeVideo;

    const getActiveVideo = () => {
      const deviceClass = mobileQuery.matches
        ? 'hitch-hero__video-wrapper--mobile'
        : 'hitch-hero__video-wrapper--desktop';
      const wrapper = wrappers.find((item) => item.classList.contains(deviceClass));

      return wrapper?.querySelector('video');
    };

    const updateControl = () => {
      if (!control) return;

      control.hidden = !activeVideo;
      if (!activeVideo) return;

      const isPlaying = !activeVideo.paused && !activeVideo.ended;
      control.dataset.state = isPlaying ? 'playing' : 'paused';
      control.setAttribute('aria-label', isPlaying ? control.dataset.pauseLabel : control.dataset.playLabel);
    };

    const pauseVideo = (video) => {
      if (!video || video.paused) return;
      video.pause();
    };

    const playActiveVideo = (userInitiated = false) => {
      if (
        !activeVideo ||
        userPaused ||
        (reducedMotionQuery.matches && !userInitiated) ||
        !isVisible ||
        document.hidden
      ) {
        updateControl();
        return;
      }

      if (activeVideo.preload === 'none') {
        activeVideo.preload = 'metadata';
        activeVideo.load();
      }

      activeVideo.muted = true;
      activeVideo.playsInline = true;
      activeVideo.play().catch(updateControl);
    };

    const switchVideo = () => {
      const nextVideo = getActiveVideo();

      wrappers.forEach((wrapper) => {
        const video = wrapper.querySelector('video');
        if (video !== nextVideo) pauseVideo(video);
      });

      activeVideo = nextVideo;
      updateControl();
      playActiveVideo();
    };

    wrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      video.addEventListener('ended', updateControl);
      video.addEventListener('error', updateControl);
    });

    control?.addEventListener('click', () => {
      if (!activeVideo) return;

      if (activeVideo.paused || activeVideo.ended) {
        userPaused = false;
        isVisible = true;
        playActiveVideo(true);
      } else {
        userPaused = true;
        activeVideo.pause();
      }
    });

    const handlePreferenceChange = () => {
      if (reducedMotionQuery.matches) {
        pauseVideo(activeVideo);
      } else {
        playActiveVideo();
      }
      updateControl();
    };

    mobileQuery.addEventListener('change', switchVideo);
    reducedMotionQuery.addEventListener('change', handlePreferenceChange);

    if (pauseWhenHidden && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            playActiveVideo();
          } else {
            pauseVideo(activeVideo);
          }
          updateControl();
        },
        { threshold: 0.1 }
      );

      observer.observe(hero);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pauseVideo(activeVideo);
      } else {
        playActiveVideo();
      }
      updateControl();
    });

    switchVideo();
    requestAnimationFrame(() => hero.classList.add('hitch-hero--ready'));
  };

  const initializeAllHeroes = (root = document) => {
    root.querySelectorAll('[data-hitch-hero]').forEach(initializeHero);
  };

  initializeAllHeroes();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllHeroes(event.target);
  });
})();
